import * as React from 'react';
import { Link } from 'react-router';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import {
  FlexColCenter,
  FlexCol,
  FlexRowCenterVertical,
  FlexRowCenter,
  FlexRow,
  FlexBetween,
} from '../../Defaults/Flexbox/Flexbox';
import { ButtonWithRequest } from './ButtonWithRequest';
import { animateIn } from '../../Zemplin/Product/ProductTabDefault';
import { StockInfo } from './StockInfo';
import { DsiTag as Tag, TagType } from './Tag';
import { FavoriteCompare } from './FavoriteCompare';
import { ProductPriceCart } from './ProductPriceCart';
import { Picture } from '../Picture/Picture';

export interface Props {
  product: any;
  name: string;
  description?: string;
  imgSrc: string | null;
  imgSrcWebP?: string | null;
  price: string;
  oldPrice: string;
  url: string;
  addToRequest: any;
  addToCart: any;
  avail_id: number;
  availability: string;
  isNew: number;
  isSale: number;
  isFavorite: boolean;
  salePercentage: string;
  currency: string;
  condition?: any;
  conditionTextMapping?: any,
  isWaiting?:boolean;
}

function ProductTabSmall({
  product,
  name,
  description,
  imgSrc,
  imgSrcWebP,
  url,
  price,
  oldPrice,
  addToCart,
  addToRequest,
  avail_id,
  availability,
  isNew,
  isSale,
  isFavorite,
  salePercentage,
  currency,
  condition, 
  conditionTextMapping,
  isWaiting
}: Props) {
  const isTag = isNew === 1 || isSale === 1;
  return (
    <Wrapper>
      <TopWrapper to={url}>
        <TagsWrapper>
          {isTag &&
            (isNew ? (
              <Tag type={TagType.NEW} text={'NOVÉ'} />
            ) : (
              <Tag type={TagType.SALE} text={'%'} />
            ))}
        </TagsWrapper>
        {/*<FavoriteCompareWrapper>*/}
        {/*  <FavoriteCompare isFavorite={isFavorite} />*/}
        {/*</FavoriteCompareWrapper>*/}
        <Picture
          alt={`Obrázok ku produktu ${name}`}
          srcNoWebP={imgSrc ? imgSrc : undefined}
          srcWebP={imgSrcWebP ? imgSrcWebP : undefined}
          customStyles={imageShared}
        />
        <Name>{name}</Name>
        <Description>{description}</Description>
      </TopWrapper>
      <MiddleWrapper>
        <ProductPriceCart
          avail_id={avail_id}
          oldPrice={oldPrice}
          price={price}
          isSale={isSale}
          addToCart={addToCart}
          addToRequest={addToRequest}
          salePercentage={salePercentage}
          product={product}
          currency={currency}
        />
      </MiddleWrapper>
      <BottomWrapper>
        <StockInfo avail_id={avail_id} availability={availability} isNew={!!isNew} condition={condition} conditionTextMapping={conditionTextMapping} isWaiting={isWaiting}/>
      </BottomWrapper>
    </Wrapper>
  );
}

const imageShared = css`
  margin-top: ${rem(16)};
  width: ${rem(160)};
  height: ${rem(160)};
  min-width: ${rem(160)};
  min-height: ${rem(160)};
  transition: transform 0.2s ease;
  &:hover {
    transform: scale(0.9);
  }
`;

const Wrapper = styled(FlexCol)`
  animation: ${animateIn} 0.3s ease;
  width: 95%;
  height: ${rem(400)};
  padding: ${rem(16)};
  box-shadow: 0px 1px 4px #00000014;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.white};

  ${({ theme }) => theme.mediab.l925`
    width: 95%;
    max-width: initial;
  `}

  ${({ theme }) => theme.mediab.m760`
    margin: 0 auto;
    max-width: initial;
    width: 100%;
    
  `}
`;

const TopWrapper = styled(Link)`
  position: relative;
  top: 0;
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 100%;
  height: ${rem(270)};
  max-height: ${rem(240)};
  text-decoration: none;
  margin-bottom: ${rem(20)};
`;

const MiddleWrapper = styled(FlexRowCenter)`
  position: relative;
  width: 100%;
  justify-content: space-between;
  margin-bottom: ${rem(20)};
`;

const BottomWrapper = styled(FlexRow)`
  bottom: 0;
`;

const Image = styled.img`
  ${imageShared}
`;

const Name = styled(TextP)`
  max-width: 100%;
  font-size: ${rem(16)};
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 500;
  text-align: center;
  max-height: ${rem(60)};
  cursor: auto;
  -webkit-user-select: text;
  -moz-select: text;
  -ms-select: text;
  user-select: text;
`;

const Description = styled(TextP)`
  font-size: ${rem(14)};
  color: #aaaaaa;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  max-height: ${rem(40)};
  cursor: auto;
  -webkit-user-select: text;
  -moz-select: text;
  -ms-select: text;
  user-select: text;
`;

const PriceCol = styled(FlexCol)``;

const PriceRow = styled(FlexRowCenterVertical)`
  margin-bottom: ${rem(4)};
`;

const Price = styled(TextP)`
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(24)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-right: ${rem(6)};
  white-space: nowrap;
  font-weight: 500;
`;

const TagsWrapper = styled(FlexBetween)`
  position: absolute;
  top: ${rem(16)};
  left: ${rem(16)};
  z-index: 110;

  ${({ theme }) => theme.mediab.m810`
      display: none;
  `}
`;

// const FavoriteCompareWrapper = styled.div`
//   position: absolute;
//   top: 0;
//   right: 0;
//   z-index: 100;
// `;

export { ProductTabSmall as DsiProductTabSmall };
